/** Time presets for the Activity Log Filters chip. `all` has no dropdown label — empty chip shows `activity.dateRange`. */
export const DATE_RANGES = [
  { value: '24h', labelKey: 'activity.range24h', hours: 24 },
  { value: '7d', labelKey: 'activity.range7d', hours: 168 },
  { value: '30d', labelKey: 'activity.range30d', hours: 720 },
  { value: 'all', hours: Infinity },
];
